import { FormattedMessage } from 'react-intl'
import Button from 'components/shared/Button'
import { ZonesModalBackButtonWrapper } from './styles'
import { closeModalActions } from 'helpers/helpers'

interface ZonesModalBackButtonProps {
    onClick: () => void
}

const ZonesModalBackButton = ({ onClick }: ZonesModalBackButtonProps) => {
    const handleOnClick = () => {
        onClick && onClick()
        closeModalActions(false)
    }

    return (
        <ZonesModalBackButtonWrapper>
            <Button variant="borderPrimary" onClick={handleOnClick}>
                <FormattedMessage
                    id="zones.modal.close_trigger"
                    defaultMessage="Wróć do wyboru stref"
                />
            </Button>
        </ZonesModalBackButtonWrapper>
    )
}

export default ZonesModalBackButton
